<template>
		<v-card>
			<v-card-title>
				Start Video Meeting
			</v-card-title>
			<v-card-text>
				<div>
					<v-radio-group v-model="joinAs" row>
						<v-radio value="moderator" label="Moderator" :disabled="hasModerator"></v-radio>
						<v-radio value="observer" label="Observer" :disabled="isModerator"></v-radio>
					</v-radio-group>
				</div>
				<div v-if="!videoAvailable" class="pt-2">
					<div v-if="passed">
						This appointment has passed
					</div>
					<div v-if="notYet">
						Video functionality is only available 10 minutes before scheduled start time
					</div>
				</div>
				<div v-else>
					<v-alert colored-border color="primary" border="left" dense outlined v-if="appointment.videoMeeting" class="pt-2">
						<span class="text-small">
							This video appointment has already started. <span v-if="hasModerator && !isModerator">The moderator for this meeting is {{appointment.videoMeeting.moderatorName}}.</span><span v-if="isModerator">You are the moderator for this meeting.</span>
						</span>
					</v-alert>
					<div v-if="joinAs == 'moderator' && !hasModerator ">					
						<v-text-field v-model="moderatorName" label="The name you'd like to show the respondent"></v-text-field>
						<v-textarea v-model="moderatorInstructions" label="Any instructions for the respondent"></v-textarea>
					</div>
					<div v-if="joinAs == 'observer'">					
						<v-text-field v-model="observerName" label="Your name"></v-text-field>
					</div>

				</div>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions v-if="videoAvailable">
					<v-spacer></v-spacer>
					<v-btn color="primary" text	@click="start" :disabled="!isModerator && (!moderatorName && !observerName)">
						Go to meeting
					</v-btn>
			</v-card-actions>		
		</v-card>
</template>


<script>

	import Vue from "vue";
	import Vuex from 'vuex'
	export default{
		name: "StartVideo", 
		props: ["appointment"],
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user
			}),
			notYet(){
				var appt = this.appointment.dateTime.toDate();
				var windowStart = Vue.moment(appt).subtract(10, 'm').toDate();
				var now = new Date();
				return now < windowStart;
			},
			passed(){
				var appt = this.appointment.dateTime.toDate();
				var windowEnd =  Vue.moment(appt).add(3, 'h').toDate();
				var now = new Date();
				return now > windowEnd;
			},
			videoAvailable(){
				var appt = this.appointment.dateTime.toDate();
				var windowStart = Vue.moment(appt).subtract(10, 'm').toDate();
				var windowEnd =  Vue.moment(appt).add(3, 'h').toDate();
				var now = new Date();
				return now > windowStart && now < windowEnd;
			},
			isModerator(){
				if( this.appointment.videoMeeting ){
					return this.appointment.videoMeeting.moderator == this.user.uid 
				}
				return false;
			},
			hasModerator(){
				if( this.appointment.videoMeeting ){
					return !(!this.appointment.videoMeeting.moderator); 
				}
				return false;
			}
		},
		data: () =>{
			return {
				observerName: "",
				moderatorName: '',
				moderatorInstructions: '', 
				joinAs: 'moderator'
			}

		},
		watch: {
			hasModerator: {
				immediate: true, 
				handler() {					
					if( this.isModerator ){
						this.joinAs = "moderator"
					}
					else{
						this.joinAs = "observer"
					}
				}
			}
		},
		methods:{
			start: function(){
				const self = this;
				var data = {}

				if( this.joinAs == 'moderator' ){
					data["videoMeeting.moderator"] = self.user.uid;
					data["videoMeeting.moderatorName"] = self.moderatorName;
					data["videoMeeting.moderatorInstructions"] = self.moderatorInstructions;
				}
				if( this.joinAs == 'observer' ){
					var observer = {
						name: self.observerName, 
						id: self.user.uid
					}					
					var observers = [];
					if( self.appointment.videoMeeting && self.appointment.videoMeeting.observers ){
						observers = self.appointment.videoMeeting.observers
					}
					observers.push( observer )
					data["videoMeeting.observers"] = observers
				}
				self.$store.dispatch("updateDoc", {
					doc: "appointments/" + self.appointment.id, 
					data: data, 
					action: "update"
				}).then( () => {				
						self.$router.push(
							{ name: "video", params: { appointment: self.appointment.id } 
						})
					} )
			}
		}
	}
</script>